<template>
   <div class="test-data-view">
      <dataview :data="data"/>
   </div>
</template>

<script>
export default {
   components:{
      'dataview': () => import("clarks/components/data-view/data-view"),
   },
   data (){
      return {
         data:{
            name: 'Geoffrey Kimani',
            email: 'geoffreykariithi@gmail.com',
            other_email: 'geoffreykariithi@gmail.com',
            other_data: {
               mega_account: 'Geoffrey Kariithi',
               birthday: '6th Aug 1997'
            },
            names: [
               'Geoffrey', 'Kimani', 'Karanja'
            ],
            users: [
               {
                  name: "John Brown",
                  age: '18',
                  address: "New York No. 1 Lake Park",
                  date: "2016-10-03",
                  extra:{
                     name: 'Hello',
                     recs: [
                        {
                           name: 'Other'
                        }
                     ]
                  },
                  job: "Data Scientist",
                  interest: "volleyball",
                  birthday: "1989-03-18",
                  book: "My Struggle",
                  movie: "Roman Holiday",
                  music: "My Heart Will Go On"
               },
               {
                  name: "Jim Green",
                  age: 24,
                  address: "London No. 1 Lake Park",
                  date: "2016-10-01",
                  extra:{
                     name: 'Hello',
                     recs: [
                        {
                           name: 'Other'
                        }
                     ]
                  },
                  job: "Data Scientist",
                  interest: "volleyball",
                  birthday: "1989-03-18",
                  book: "My Struggle",
                  movie: "Roman Holiday",
                  music: "My Heart Will Go On"
                  // children: [
                  //    {
                  //       name: 'Joe Black',
                  //       age: 30,
                  //       address: 'Sydney No. 1 Lake Park',
                  //       date: '2016-10-02'
                  //    },
                  //    {
                  //       name: 'Jon Snow',
                  //       age: 26,
                  //       address: 'Ottawa No. 2 Lake Park',
                  //       date: '2016-10-04'
                  //    }
                  // ]
               },
               {
                  name: "Joe Black",
                  age: 30,
                  address: "Sydney No. 1 Lake Park",
                  date: "2016-10-02",
                  extra:{
                     name: 'Hello',
                     recs: [
                        {
                           name: 'Other'
                        }
                     ]
                  },
                  job: "Data Scientist",
                  interest: "volleyball",
                  birthday: "1989-03-18",
                  book: "My Struggle",
                  movie: "Roman Holiday",
                  music: "My Heart Will Go On"
               },
            ]
         },
         users: [
            {
               name: "John Brown",
               age: '18',
               address: "New York No. 1 Lake Park",
               date: "2016-10-03",
               extra:{
                  name: 'Hello',
                  recs: [
                     {
                        name: 'Other'
                     }
                  ]
               },
               job: "Data Scientist",
               interest: "volleyball",
               birthday: "1989-03-18",
               book: "My Struggle",
               movie: "Roman Holiday",
               music: "My Heart Will Go On"
            },
            {
               name: "Jim Green",
               age: 24,
               address: "London No. 1 Lake Park",
               date: "2016-10-01",
               extra:{
                  name: 'Hello',
                  recs: [
                     {
                        name: 'Other'
                     }
                  ]
               },
               job: "Data Scientist",
               interest: "volleyball",
               birthday: "1989-03-18",
               book: "My Struggle",
               movie: "Roman Holiday",
               music: "My Heart Will Go On"
               // children: [
               //    {
               //       name: 'Joe Black',
               //       age: 30,
               //       address: 'Sydney No. 1 Lake Park',
               //       date: '2016-10-02'
               //    },
               //    {
               //       name: 'Jon Snow',
               //       age: 26,
               //       address: 'Ottawa No. 2 Lake Park',
               //       date: '2016-10-04'
               //    }
               // ]
            },
            {
               name: "Joe Black",
               age: 30,
               address: "Sydney No. 1 Lake Park",
               date: "2016-10-02",
               extra:{
                  name: 'Hello',
                  recs: [
                     {
                        name: 'Other'
                     }
                  ]
               },
               job: "Data Scientist",
               interest: "volleyball",
               birthday: "1989-03-18",
               book: "My Struggle",
               movie: "Roman Holiday",
               music: "My Heart Will Go On"
            },
            {
               name: "Jon Snow",
               age: 26,
               address: "Ottawa No. 2 Lake Park",
               date: "2016-10-04",
               extra:{
                  name: 'Hello',
                  recs: [
                     {
                        name: 'Other'
                     }
                  ]
               },
               job: "Data Scientist",
               interest: "volleyball",
               birthday: "1989-03-18",
               book: "My Struggle",
               movie: "Roman Holiday",
               music: "My Heart Will Go On"
            },
            {
               name: "Joe Black",
               age: 30,
               address: "Sydney No. 1 Lake Park",
               date: "2016-10-02",
               extra:{
                  name: 'Hello',
                  recs: [
                     {
                        name: 'Other'
                     }
                  ]
               },
               job: "Data Scientist",
               interest: "volleyball",
               birthday: "1989-03-18",
               book: "My Struggle",
               movie: "Roman Holiday",
               music: "My Heart Will Go On"
            },
            {
               name: "Jon Snow",
               age: 26,
               address: "Ottawa No. 2 Lake Park",
               date: "2016-10-04",
               extra:{
                  name: 'Hello',
                  recs: [
                     {
                        name: 'Other'
                     }
                  ]
               },
               job: "Data Scientist",
               interest: "volleyball",
               birthday: "1989-03-18",
               book: "My Struggle",
               movie: "Roman Holiday",
               music: "My Heart Will Go On"
            },
            {
               name: "Joe Black",
               age: 30,
               address: "Sydney No. 1 Lake Park",
               date: "2016-10-02",
               extra:{
                  name: 'Hello',
                  recs: [
                     {
                        name: 'Other'
                     }
                  ]
               },
               job: "Data Scientist",
               interest: "volleyball",
               birthday: "1989-03-18",
               book: "My Struggle",
               movie: "Roman Holiday",
               music: "My Heart Will Go On"
            },
            {
               name: "Jon Snow",
               age: 26,
               address: "Ottawa No. 2 Lake Park",
               date: "2016-10-04",
               extra:{
                  name: 'Hello',
                  recs: [
                     {
                        name: 'Other'
                     }
                  ]
               },
               job: "Data Scientist",
               interest: "volleyball",
               birthday: "1989-03-18",
               book: "My Struggle",
               movie: "Roman Holiday",
               music: "My Heart Will Go On"
            },
            {
               name: "Jon Snow",
               age: 26,
               address: "Ottawa No. 2 Lake Park",
               date: "2016-10-04",
               extra:{
                  name: 'Hello',
                  recs: [
                     {
                        name: 'Other'
                     }
                  ]
               },
               job: "Data Scientist",
               interest: "volleyball",
               birthday: "1989-03-18",
               book: "My Struggle",
               movie: "Roman Holiday",
               music: "My Heart Will Go On"
            },
            {
               name: "Joe Black",
               age: 30,
               address: "Sydney No. 1 Lake Park",
               date: "2016-10-02",
               extra:{
                  name: 'Hello',
                  recs: [
                     {
                        name: 'Other'
                     }
                  ]
               },
               job: "Data Scientist",
               interest: "volleyball",
               birthday: "1989-03-18",
               book: "My Struggle",
               movie: "Roman Holiday",
               music: "My Heart Will Go On"
            },
            {
               name: "Jon Snow",
               age: 26,
               address: "Ottawa No. 2 Lake Park",
               date: "2016-10-04",
               extra:{
                  name: 'Hello',
                  recs: [
                     {
                        name: 'Other'
                     }
                  ]
               },
               job: "Data Scientist",
               interest: "volleyball",
               birthday: "1989-03-18",
               book: "My Struggle",
               movie: "Roman Holiday",
               music: "My Heart Will Go On"
            }
         ]
      };
   },
   mounted(){

   }
}
</script>

<style lang="scss">
   .test-data-view{
      
   }
</style>